export const SECTOR_OPTIONS = [
  "Logistics","Transportation","Consulting","Manufacturing","Retail","Energy","Technology","Ports & Maritime","Construction","FMCG"
];

export const FORUM_TOPIC_OPTIONS = [
  "AI Adoption", "Air", "Carbon Accounting", "Certification", "Change Management", "Commercialisation",
  "Electrification", "Freight", "Ocean", "Rail", "Road", "SLL Member News",
  "Sustainable Logistics LIVE", "Warehousing/ Fulfilment", "General"
];


export const INTERESTS_OPTIONS = [
  "Circular Economy","Green Logistics","Decarbonisation","ESG Investing",
  "Sustainable Aviation Fuel","Hydrogen Economy","Electric Vehicles",
  "Carbon Markets","Climate Adaptation","Regenerative Agriculture",
  "Smart Cities","Green Finance","Just Transition","Ocean Freight Innovation",
  "Supply Chain Resilience","AI & Sustainability","Digital Twins",
  "Scope 3 Solutions","Green Warehousing","Sustainable Last-Mile",
  "Net Zero Targets","Climate Tech","Renewable Energy","Ethical Trade",
  "Biodiversity","Social Impact","Plastic Alternatives"
];

export const PRIORITY_2026_OPTIONS = [
  "Scope 3 reduction","Fleet electrification","ESG reporting compliance",
  "Supplier decarbonisation","Net zero roadmap","Sustainable packaging transition",
  "CSRD/CBAM compliance","Carbon neutrality","Renewable energy procurement",
  "Digital supply chain transformation","Circular economy implementation",
  "Workforce green skills development","Biodiversity strategy",
  "Water stewardship programme","Social value measurement",
  "AI integration for sustainability","Last-mile innovation",
  "Modal shift to rail/water","Green procurement policy","Climate risk assessment"
];

export const COMMUNITY_GOALS_OPTIONS = [
  "Networking with peers","Learning best practices","Event awareness & attendance",
  "Finding technology partners","Industry benchmarking","Mentorship opportunities",
  "Collaboration on projects","Knowledge sharing","Policy & advocacy",
  "Career development","Speaking opportunities","Research partnerships",
  "Supplier discovery","Staying informed on regulation","Connecting with consultants"
];

export const EXPERTISE_OPTIONS = [
  "Carbon Accounting","Fleet Electrification","Warehouse Automation","Scope 3 Emissions",
  "Circular Economy","Reverse Logistics","Green Procurement","Sustainable Packaging",
  "ESG Reporting","Climate Risk Assessment","Supply Chain Mapping","Last-Mile Delivery",
  "Renewable Energy Integration","Carbon Offsetting","Net Zero Strategy","Life Cycle Assessment",
  "ISO 14001 Implementation","Science Based Targets","Hydrogen Fuel Cells","Biofuels",
  "Route Optimisation","Modal Shift","Rail Freight","Cold Chain Management",
  "Supplier Auditing","Ethical Sourcing","Waste Reduction","Water Stewardship",
  "AI for Supply Chain","Digital Twin Technology","Blockchain Traceability","IoT Monitoring",
  "EV Charging Infrastructure","Alternative Fuels","Carbon Capture","Emissions Trading"
];

export const CHALLENGES_OPTIONS = [
  "Reducing Scope 3 emissions","Last-mile decarbonisation","Supplier ESG compliance",
  "Measuring carbon footprint accurately","Transitioning to electric fleet",
  "Sustainable packaging alternatives","Reducing warehouse energy use",
  "Cold chain sustainability","Balancing cost vs sustainability",
  "ESG data collection & reporting","Engaging suppliers on net zero",
  "Regulatory compliance (CSRD, CBAM)","Reducing returns & reverse logistics waste",
  "Finding green technology partners","Securing sustainability funding",
  "Workforce transition & green skills","Scope 2 renewable sourcing",
  "Freight modal shift barriers","Urban logistics emissions"
];

export const LOOKING_FOR_OPTIONS = [
  "Collaboration on projects","Technology partners","Mentorship",
  "Knowledge sharing","Industry benchmarking","Joint ventures",
  "Supplier introductions","Peer networking","Advisory board roles",
  "Speaking opportunities","Research partnerships","Pilot programmes"
];

export const QUALIFICATIONS_OPTIONS = [
  "MBA","MSc Sustainability","MSc Supply Chain Management","BSc Environmental Science",
  "CILT (Chartered Institute of Logistics & Transport)","IEMA Certificate/Diploma",
  "NEBOSH","ISO 14001 Lead Auditor","Prince2","Six Sigma",
  "CIPS (Chartered Institute of Procurement & Supply)","PhD",
  "PMP","APICS CSCP","GRI Certified Sustainability Professional",
  "Cambridge Institute for Sustainability Leadership","BREEAM",
  "LEED AP","Carbon Literacy Certified","CDP Accredited"
];

export const CERTIFICATIONS_OPTIONS = [
  "ISO 14001","ISO 50001","B Corp","Science Based Targets (SBTi)",
  "CDP A-List","EcoVadis Gold","IEMA Associate","GRI Certified",
  "LEED Professional","BREEAM Assessor","CILT Chartered",
  "NEBOSH Environmental","Six Sigma Green Belt"
];

export const GOALS_OPTIONS = [
  "Net Zero by 2030","Net Zero by 2040","Net Zero by 2050",
  "100% renewable energy","Zero waste to landfill","50% emissions reduction by 2030",
  "Carbon neutral operations","Science-based targets validated",
  "100% sustainable packaging","EV-only fleet by 2035",
  "Scope 3 reduction 30%","Water neutral operations"
];

export const PROJECTS_OPTIONS = [
  "EV fleet transition","Carbon neutral warehousing","Scope 3 mapping programme",
  "Sustainable packaging redesign","Green last-mile pilots","Hydrogen truck trials",
  "Supply chain transparency platform","Circular economy programme",
  "Net zero roadmap development","ESG reporting automation",
  "Rail freight expansion","Renewable energy procurement",
  "Supplier decarbonisation programme","AI-powered route optimisation","Digital twin implementation"
];

export const SELF_DESCRIPTION_OPTIONS = [
  "Strategist","Innovator","Practitioner","Researcher","Advocate",
  "Operator","Consultant","Educator","Entrepreneur","Policy Maker",
  "Data-Driven","Collaborative","Hands-On","Visionary","Technical"
];

export const SPECIALIST_AREAS_OPTIONS = [
  "Last Mile Delivery","Cold Chain Logistics","Warehouse Automation","Freight & Haulage",
  "Maritime & Ports","Aviation & Air Freight","Rail Logistics","Urban Logistics",
  "Reverse Logistics","E-commerce Fulfilment","Dangerous Goods","Pharmaceutical Supply Chain",
  "Food & Beverage Supply Chain","Fashion & Textiles Supply Chain","Construction Logistics",
  "Defence & Government Logistics","Energy Supply Chain","Automotive Supply Chain",
  "Cross-Border Trade","Customs & Compliance","3PL/4PL Management",
  "Fleet Management","Transport Planning","Procurement & Sourcing",
  "Supply Chain Finance","Risk & Resilience","Digital Transformation"
];

export const COUNTRY_OPTIONS = [
  "United Kingdom","Ireland","France","Germany","Netherlands","Belgium","Spain","Italy",
  "Sweden","Norway","Denmark","Finland","Poland","Switzerland","Austria","Portugal",
  "United States","Canada","Australia","New Zealand","India","China","Japan",
  "Singapore","UAE","South Africa","Brazil","Mexico","Other"
];

export const STAKEHOLDER_TYPE_OPTIONS = [
  "Academia","Consultancy","Service Provider","Student","Corporate","Logistics","NGO/Non-Profit"
];

// Color map for stakeholder type pills
export const STAKEHOLDER_COLORS = {
  "Academia": "bg-violet-100 text-violet-700",
  "Consultancy": "bg-sky-100 text-sky-700",
  "Service Provider": "bg-amber-100 text-amber-700",
  "Student": "bg-emerald-100 text-emerald-700",
  "Corporate": "bg-slate-200 text-slate-700",
  "Logistics": "bg-blue-100 text-blue-700",
  "NGO/Non-Profit": "bg-rose-100 text-rose-700",
};

export const AGE_GROUP_OPTIONS = [
  "18-24","25-34","35-44","45-54","55-64","65+"
];

export const GENDER_OPTIONS = [
  "Male","Female","Non-binary","Prefer not to say"
];

export const REGION_OPTIONS = [
  "Europe","North America","Central & South America","Asia Pacific",
  "Middle East","Africa","Australasia","Global"
];

export const YEARS_SUSTAINABLE_LOGISTICS_OPTIONS = [
  "Less than 1 year","1-5 years","5-10 years","10+ years"
];
